import { Details } from '../models/details.interfaces';

export const StandardSkyMilesMedallionBannerDetailsMocks: Details = {
  title: 'Good Morning, Rocky',
  action: {
    label: 'VIEW YOUR BENEFITS',
    url: '/us/en/skymiles/medallion-program/medallion-benefits'
  },
  milesData: {
    skyMiles: { title: 'SKYMILES #', subtitle: '8006270311' },
    miles: { title: 'MILES AVAILABLE', subtitle: '38,000' }
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'SKYMILES® MEMBER',
    level: '0',
    name: 'skymiles'
  }
};

export const StandardSkyMilesMillionMilerMedallionBannerDetailsMocks: Details =
  {
    title: 'Good Morning, Rocky',
    action: {
      label: 'VIEW YOUR BENEFITS',
      url: '/us/en/skymiles/medallion-program/medallion-benefits'
    },
    milesData: {
      skyMiles: { title: 'SKYMILES #', subtitle: '8006270311' },
      miles: { title: 'MILES AVAILABLE', subtitle: '38,000' }
    },
    tier: {
      title: '2023 CURRENT STATUS: ',
      subtitle: 'SKYMILES® MEMBER',
      level: '1',
      name: 'skymiles'
    }
  };

export const StandardSkyMilesMedallionBannerWithLifetimeDetailsMocks: Details =
  {
    title: 'Good Morning, Rocky',
    action: {
      label: 'VIEW YOUR BENEFITS',
      url: '/us/en/skymiles/medallion-program/medallion-benefits'
    },
    milesData: {
      skyMiles: { title: 'SKYMILES #', subtitle: '8006270311' },
      miles: { title: 'MILES AVAILABLE', subtitle: '38,000' }
    },
    tier: {
      title: 'CURRENT STATUS: ',
      subtitle: 'SKYMILES® MEMBER',
      level: '0',
      name: 'skymiles'
    }
  };

export const MedallionBannerStatusMocks: Details = {
  title: 'Good Morning, Rocky',
  action: {
    label: 'VIEW YOUR BENEFITS',
    url: '/us/en/skymiles/medallion-program/medallion-benefits'
  },
  milesData: {
    skyMiles: { title: 'SKYMILES #', subtitle: '8006270311' },
    miles: { title: 'MILES AVAILABLE', subtitle: '38,0000' }
  },
  tier: {
    title: 'CURRENT STATUS: ',
    subtitle: 'SKYMILES® MEMBER',
    level: '0',
    name: 'skymiles'
  }
};
